import {ISettingTypeState} from 'src/app/modules/siteSettings/components/settings'
import {toAbsoluteUrl} from '../../../helpers'
import {imageBaseUrl} from 'src/cms/helpers/constants'
import {useSelector} from 'react-redux'
import {useEffect, useState} from 'react'
import {isEmpty} from 'lodash'
export function FallbackView() {
  const [logo, setLogo] = useState('')
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)
  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Theme settings']?.map((item: any) => {
          if (item?.name === 'mainLogo') {
            setLogo(item?.value)
          }
        })
    }
  }, [settingTypeData])

  return (
    <div className='splash-screen'>
      <img
        src={`${imageBaseUrl}/${logo}` || `/media/logos/global-ime-logo-svg.jpg`}
        alt='Start logo'
      />
      {/* <span>Loading ...</span> */}
    </div>
  )
}
